import React from 'react';
import Modal from 'react-modal';
import closeIcon from '../../../assets/images/close-icon.svg';
import './index.scss';

export interface IAppModal {
  isOpen: boolean;
  onClose: (e: any) => void;
  hideCloseIcon?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'custom';
  children?: React.ReactNode;
  customClassName?: string;
  adjustToContent?: boolean;
  maxWidth?: string | number;
}

const AppModal = ({ isOpen, onClose, size = 'md', children, hideCloseIcon = false, customClassName, adjustToContent = false, maxWidth }: IAppModal) => {

  // Passed as a CSS variable so it can override the !important max-widths on the size/adjust-to-content classes
  const contentStyle = maxWidth
    ? ({ '--app-modal-max-width': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth } as React.CSSProperties)
    : {};

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName={`modalOverlay`}
      className={`modalContent ${size}${adjustToContent ? ' adjust-to-content' : ''}${maxWidth ? ' has-max-width' : ''} ${customClassName ? customClassName : ''}`}
      style={{ content: contentStyle, overlay: {} }}
    >
      {!hideCloseIcon && <img src={closeIcon} alt="close_icon" className="tw-absolute tw-top-1 tw-right-1 tw-cursor-pointer tw-w-4 tw-z-10" role="presentation" onClick={onClose} />}
      {children}
    </Modal>
  );

}

export default AppModal;